import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TalkAiAgentRoutingModule } from './talk-ai-agent-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgentServiceService } from './agent-service.service';
import { RouterModule } from '@angular/router';
import { TalkAiAgentComponent } from './talk-ai-agent.component';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TalkAiAgentRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TalkAiAgentComponent
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers:[
    AgentServiceService
  ]
})
export class TalkAiAgentModule { }
